import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id", "type", "required", "placeholder"]
const _hoisted_2 = {
  key: 3,
  class: /*#__PURE__*/_normalizeClass([
        'absolute left-0 w-full px-2 pb-2 max-h-[300px] overflow-y-auto bg-white shadow-border-gray-300-no-top duration-500 z-[41]',
        //isRounded ? 'rounded-b' : null,
        //isRelative ? 'relative' : 'absolute top-full',
        //isLoading || isLoadingInit ? 'min-h-[34px]' : null,
      ])
}
const _hoisted_3 = { class: "h-full overflow-y-auto" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-full flex items-center justify-between py-0.5 leading-6 text-left min-h-[26px]" }
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass([
                  'font-roboto-condensed text-[12.8px]',
                  'text-zbr-black-900',
                ])
}

import { ref, computed, watch, onMounted, onUpdated } from 'vue';
import { onClickOutside } from '@vueuse/core';
import IconEye from '@/components/icons/IconEye.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    modelValue: { default: '' },
    id: {},
    type: { default: 'text' },
    label: { default: '' },
    placeholder: { default: '' },
    customClass: { default: '' },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    rounded: { type: Boolean, default: true },
    prepend: { type: Boolean, default: false },
    labelPrepend: { default: '' },
    labelClass: { default: '' },
    isSuggestData: { type: Boolean, default: false },
    suggestData: { default: () => ([]) }
  },
  emits: ['update:modelValue', 'blur', 'on-select-suggest-item'],
  setup(__props: any, { emit }) {

const props = __props;



const selfValue = ref<string | number>(props.modelValue);
const focused = ref(false);
const isShowPassword = ref(false);
const inputPaddingLeft = ref(0);

const isOpenSuggestData = ref(false);
const inputRef = ref<any>(null);

// Computed
const isFilled = computed(() => selfValue.value || focused.value);
const computedType = computed(() => {
  if (props.type === 'password' && isShowPassword.value) {
    return 'text';
  }
  if (props.type === 'tel') {
    return 'text';
  }
  return props.type;
});
const onTypeSuggestData = computed(() => {
  if (props.suggestData.length === 0) {
    return [];
  }
  const searchValue = selfValue.value.toString().toLowerCase();
  return props.suggestData.slice().filter((item: any) => {
    return item.label.toLowerCase().includes(searchValue);
  });
});

// Watchers
watch(() => props.modelValue, (newValue) => {
  selfValue.value = newValue;
});

onMounted(() => {
  if (props.prepend && props.labelPrepend) {
    setInputPaddingLeft();
  }
});

onUpdated(() => {
  if (props.prepend && props.labelPrepend) {
    setInputPaddingLeft();
  }
});

// Methods
function checkOnInput(e: Event) {
  // autocomplete on iPhone doesn`t fire checkOnKeyup()
  // this function adds additional check of input value
  const element = e.target as HTMLInputElement;
  const value = element.value;

  if (props.type !== 'tel') {
    emit('update:modelValue', value);
    return;
  }

  const strValueNoText = value.toString().replace(/[^0-9]/g, '');
  if (strValueNoText.length === 0 || strValueNoText.trim().length === 0) {
    selfValue.value = '';
    emit('update:modelValue', '');
    return;
  }
  if (strValueNoText.trim().length < 2) {
    emit('update:modelValue', strValueNoText);
    return;
  }
  const adjustedTelValue = strValueNoText.replace(/^(\d{2})?(\d{4})?(\d{4})?/g, '$1 $2 $3');
  emit('update:modelValue', adjustedTelValue);
}
function onFocus() {
  focused.value = true;
  isOpenSuggestData.value = true;
}
function onBlur(e: FocusEvent) {
  const element = e.target as HTMLInputElement;
  if (!element.value) {
    focused.value = false;
  }
  emit('blur', e);
}
function onShowPassword() {
  isShowPassword.value = !isShowPassword.value;
}
function setInputPaddingLeft() {
  const labelPrelendElem = document.querySelector(`.label-prepend-${props.labelClass}`) as HTMLElement;
  if (labelPrelendElem) {
    inputPaddingLeft.value = labelPrelendElem.offsetWidth + 24;
  }
}
function onSelectItem(item: any) {
  isOpenSuggestData.value = false;
  emit('on-select-suggest-item', item);
}

onClickOutside(inputRef, () => {
  isOpenSuggestData.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "inputRef",
    ref: inputRef,
    class: _normalizeClass([
      'relative base-input',
      _ctx.disabled ? 'pointer-events-none opacity-50' : null,
      _ctx.rounded ? 'rounded' : null,
    ])
  }, [
    _withDirectives(_createElementVNode("input", {
      id: _ctx.id,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selfValue).value = $event)),
      type: computedType.value,
      required: _ctx.required,
      placeholder: _ctx.label ? '' : _ctx.placeholder,
      class: _normalizeClass([
        'input-field',
        _ctx.error ? 'is-error' : null,
        _ctx.rounded ? 'rounded' : null,
        _ctx.prepend ? 'prepend' : null,
        _ctx.customClass
      ]),
      style: _normalizeStyle(
        _ctx.prepend && _ctx.labelPrepend ? { paddingLeft: `${inputPaddingLeft.value}px` } : {}
      ),
      onFocus: onFocus,
      onBlur: onBlur,
      onInput: checkOnInput
    }, null, 46, _hoisted_1), [
      [_vModelDynamic, selfValue.value]
    ]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['label', isFilled.value ? 'focused' : null])
        }, _toDisplayString(_ctx.label), 3))
      : _createCommentVNode("", true),
    (_ctx.labelPrepend)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass([
        'label-prepend',
        `label-prepend-${_ctx.labelClass}`
      ])
        }, _toDisplayString(_ctx.labelPrepend), 3))
      : _createCommentVNode("", true),
    (_ctx.type === 'password')
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          class: "toggle-psw-btn",
          onClick: onShowPassword
        }, [
          _createVNode(IconEye, { show: isShowPassword.value }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSuggestData && isOpenSuggestData.value && onTypeSuggestData.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, {
            mode: "out-in",
            "enter-active-class": "transition ease-out duration-100",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition ease-in duration 100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onTypeSuggestData.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${item.label}-${index}`,
                    class: _normalizeClass([
              'group border-b border-zbr-gray-200 hover:bg-zbr-primary-50',
              index === onTypeSuggestData.value.length - 1 ? 'border-b-0' : null
            ]),
                    onClick: ($event: any) => (onSelectItem(item))
                  }, [
                    _createElementVNode("button", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(item.label)), 1)
                    ])
                  ], 10, _hoisted_4))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})